var map = {
	"./404/routes.ts": "0ac4",
	"./code-help/routes.ts": "2f58",
	"./index/routes.ts": "bb14",
	"./main/routes.ts": "2b4f",
	"./system/routes.ts": "6cc0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7498";